import React from 'react';

const Top1Shape = ({ className }) => {
  return (
    <svg
      className={className}
      width="402"
      height="749"
      viewBox="0 0 402 749"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M179 204.5C135.131 332.082 262.771 412.833 282.028 499.479C301.285 586.125 402 691 402 691L402 346.5L402 88.9992L0.50002 88.9993C18.8196 122.592 210.057 114.18 179 204.5Z"
        fill="white"
      />
    </svg>
  );
};

export default Top1Shape;
